import * as React from 'react';
import { useCallback } from 'react';
import {
	Dropdown,
	DropdownCheckboxItem,
	DropdownContent,
	DropdownItem,
	DropdownSelectTrigger,
	DropdownSeparator,
} from '../../../../../web/components-v2/Dropdown';
import { bs } from '../../../../../web/styles/styles';
import { useOfficeLocationAutocompleteQuery } from '../../../../queries/Aida/useOfficeLocationAutocomplete';

interface IProps {
	onChange?: (values: string[]) => void;
	selectedOfficeLocations?: string[];
}

export const OfficeLocationMultiSelect: React.FC<IProps> = ({ onChange, selectedOfficeLocations = [] }) => {
	const { data: officeLocations = [], isPending, isError } = useOfficeLocationAutocompleteQuery();

	const handleToggle = useCallback(
		(value: string) => {
			const next = selectedOfficeLocations.includes(value)
				? selectedOfficeLocations.filter(item => item !== value)
				: [...selectedOfficeLocations, value];
			onChange?.(next);
		},
		[selectedOfficeLocations, onChange]
	);

	const handleClearAll = useCallback(() => {
		onChange?.([]);
	}, [onChange]);

	const checkedCount = selectedOfficeLocations.length;
	const isEmpty = !isPending && !isError && officeLocations.length === 0;
	const message = isPending
		? 'Loading offices...'
		: isError
			? 'Error loading offices'
			: isEmpty
				? 'No offices configured'
				: checkedCount === 0
					? 'Select offices...'
					: `${checkedCount} office${checkedCount === 1 ? '' : 's'} selected`;

	return (
		<Dropdown>
			<DropdownSelectTrigger styles={[bs.wFull]} disabled={isPending || isEmpty}>
				{message}
			</DropdownSelectTrigger>
			<DropdownContent>
				{!isPending &&
					!isError &&
					officeLocations.map(office => (
						<DropdownCheckboxItem
							key={office}
							checked={selectedOfficeLocations.includes(office)}
							onCheckedChange={() => handleToggle(office)}
						>
							{office}
						</DropdownCheckboxItem>
					))}
				{checkedCount > 0 && (
					<>
						<DropdownSeparator />
						<DropdownItem onClick={handleClearAll}>Clear all</DropdownItem>
					</>
				)}
			</DropdownContent>
		</Dropdown>
	);
};
